import { apiClient, API_ENDPOINTS } from './config.js';

// 页面内容管理 API
export const pageContentApi = {
  // 获取可用页面列表
  async getAvailablePages() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PAGE_CONTENT.PAGES);
      return response;
    } catch (error) {
      console.error('获取页面列表失败:', error);
      throw error;
    }
  },

  // 获取页面内容
  async getPageContent(pageName) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PAGE_CONTENT.GET(pageName));
      return response;
    } catch (error) {
      console.error(`获取页面 ${pageName} 内容失败:`, error);
      throw error;
    }
  },

  // 更新页面内容
  async updatePageContent(pageName, contentData) {
    try {
      const response = await apiClient.put(API_ENDPOINTS.PAGE_CONTENT.UPDATE(pageName), contentData);
      return response;
    } catch (error) {
      console.error(`更新页面 ${pageName} 内容失败:`, error);
      throw error;
    }
  }
};

export default pageContentApi; 